import { lazy } from 'react';
import type { AppModule } from '@/app/module-registry';

const DashboardPage = lazy(() => import('./DashboardPage'));
const NewListingPage = lazy(() => import('./NewListingPage'));
const MyListingsPage = lazy(() => import('./MyListingsPage'));
const EditListingPage = lazy(() => import('./EditListingPage'));
const MySubscriptionPage = lazy(() => import('./MySubscriptionPage'));
const LeadsPage = lazy(() => import('./LeadsPage'));
const PrivacyPage = lazy(() => import('./PrivacyPage'));

export const advertiserModule: AppModule = {
  key: 'advertiser',
  order: 20,
  routes: [
    /*
      "Anunciar" EXIGE CONTA. Quem chega deslogado é levado ao cadastro e volta
      para cá — o roteador cuida disso em `RequireAccount`.

      Era público, na intenção de que "o cadastro acontecesse no fim". Não
      acontecia: o visitante preenchia oito etapas, subia as fotos, e recebia
      401 ao publicar.
    */
    { path: 'anunciar', element: <NewListingPage /> },
  ],
  advertiserRoutes: [
    { index: true, element: <DashboardPage /> },
    { path: 'anuncios', element: <MyListingsPage /> },
    { path: 'leads', element: <LeadsPage /> },
    { path: 'anuncios/:id/editar', element: <EditListingPage /> },
    { path: 'assinatura', element: <MySubscriptionPage /> },
    { path: 'privacidade', element: <PrivacyPage /> },
  ],
};
